
function DNDVideo({card, language, elementStyle, changeSelection}) {

    return (
      <div
        id="componentContainer"
        data-tour="rpdesigner-step-3"
        style={elementStyle}
        onClick={changeSelection}
      >
        <video
          id="video"
          src={card?.value[0].languages[language]}
          controls
          style={{ maxWidth: "98%" }}
        >
          Your browser cannot play this video.
          <br />
          This movie shows a demonstration of the video element.
        </video>

        <input
          readOnly
          id="displayDefault"
          style={{ display: "none" }}
          value={card.displayDefault}
        />
        
        <input
          readOnly
          id="displaySuccess"
          style={{ display: "none" }}
          value={card.displaySuccess}
        />
        <input
          readOnly
          id="displayError"
          style={{ display: "none" }}
          value={card.displayError}
        />
        <input
          readOnly
          id="redirectFromVideo"
          style={{ display: "none", }}
          value={(card.value.find(({ name }) => name === 'redirectFromVideo') || { languages: { en: '' } }).languages['en']}
        />

        <input
          readOnly
          id="autoplayButton"
          style={{ display: "none" }}
          value={card.autoplayButton}
        />
       
      </div>
    );
}

export default DNDVideo;